import { render, staticRenderFns } from "./AnswerSave.vue?vue&type=template&id=f0661edc&"
import script from "./AnswerSave.vue?vue&type=script&lang=js&"
export * from "./AnswerSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports